import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from './views/Dashboard'
import Statistics from './views/Statistics'
import Calendar from './views/Calendar'
import Logbook from './views/Logbook'
import TrainningActivity from './views/TrainningActivity'
import Login from './views/Login'
import ScientificActivity from './views/ScientificActivity'
import Callback from './views/AuthCallback'
import Profile from './views/Profile'
import Contacts from './views/Contacts'
import Admin from './views/Admin'
import Contact from './views/Contact'
import Internships from './views/Internships'
import Partners from './views/Partners'
import Logout from './views/Logout'
import authenticator from '@/services/authenticator'
import store from '@/store'
import OtherActivities from '@/views/OtherActivities'
import XerpaLearn from '@/views/XerpaLearn'
import Stats from '@/views/Stats'
import Coordination from '@/views/Coordination'
import InternsList from '@/views/InternsList'
import InternStats from '@/views/InternStats'
import Maintenance from '@/views/Maintenance'
import Workplaces from '@/views/Workplaces'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/statistics',
      name: 'Statistics',
      component: Statistics
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/callback',
      name: 'Callback',
      component: Callback
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout
    },
    {
      path: '/curriculum',
      name: 'Curriculum',
      component: ScientificActivity
    },
    {
      path: '/other-activities',
      name: 'OtherActivities',
      component: OtherActivities
    },
    {
      path: '/internships',
      name: 'Internships',
      component: Internships
    },
    {
      path: '/logbook',
      name: 'Logbook',
      component: Logbook
    },
    {
      path: '/calendar',
      name: 'Calendar',
      component: Calendar
    },
    {
      path: '/contacts',
      name: 'Contacts',
      component: Contacts
    },
    {
      path: '/contacts/:contactId',
      name: 'Contact',
      component: Contact,
      props: true
    },
    {
      path: '/course',
      name: 'Course',
      component: TrainningActivity
    },
    {
      path: '/partners',
      name: 'Partners',
      component: Partners
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin
    },
    {
      path: '/xerpaLearn',
      name: 'Xerpa Learn',
      component: XerpaLearn
    },
    {
      path: '/stats',
      name: 'Stats',
      component: Stats
    },
    {
      path: '/internsList',
      name: 'InternsList',
      component: InternsList
    },
    {
      path: '/coordination',
      name: 'Coordination',
      component: Coordination
    },
    {
      path: '/internStats',
      name: 'InternStats',
      component: InternStats
    },
    {
      path: '/maintenance',
      name: 'Maintenance',
      component: Maintenance
    },
    {
      path: '/workplaces',
      name: 'Workplaces',
      component: Workplaces
    }
  ]
})

router.beforeEach((to, _from, next) => {
  if (to.path === '/docs') {
    return (window.location = `${location.origin}/docs/`)
  }
  if (
    to.path === '/login' ||
    to.path === '/callback' ||
    store.state.auth.authenticated
  ) {
    return next()
  }

  const auth = new authenticator()
  auth.login({ appState: { to: to.path } })
})

export default router
